<app-content-wrapper [headerTitle]="'Dashboard'">
  <div main-content>


<!--      <div class="col-span-12 md:col-span-4">-->
<!--        <div class="bg-[#f5f6fa] p-3 rounded-xl">-->
<!--          <h3 class="mb-4 text-lg font-semibold text-gray-700 border-b pb-2 border-gray-200">Monitor Status</h3>-->

<!--          <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 justify-center">-->
<!--            &lt;!&ndash; Campaign Sent &ndash;&gt;-->
<!--            <div class="bg-white rounded-md shadow-sm p-4 text-center">-->
<!--              <div class="text-sm text-gray-500 mb-1">DOWN</div>-->
<!--              <i class="pi pi-arrow-down text-2xl text-gray-600 mb-1"></i>-->
<!--              <div class="text-xl font-semibold text-gray-700">{{ downCount }}</div>-->
<!--            </div>-->

<!--            &lt;!&ndash; Annual Profit &ndash;&gt;-->
<!--            <div class="bg-white rounded-md shadow-sm p-4 text-center">-->
<!--              <div class="text-sm text-gray-500 mb-1">UP</div>-->
<!--              <i class="pi pi-arrow-up text-2xl text-gray-600 mb-1"></i>-->
<!--              <div class="text-xl font-semibold text-gray-700">{{ upCount }}</div>-->
<!--            </div>-->

<!--            &lt;!&ndash; Lead Conversation &ndash;&gt;-->
<!--            <div class="bg-white rounded-md shadow-sm p-4 text-center">-->
<!--              <div class="text-sm text-gray-500 mb-1">PAUSED</div>-->
<!--              <i class="pi pi-pause text-2xl text-gray-600 mb-1"></i>-->
<!--              <div class="text-xl font-semibold text-gray-700">{{ pausedCount
 }}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="col-span-12 md:col-span-8">-->
<!--        <div class="bg-[#f5f6fa] p-3 rounded-xl">-->
<!--          @if (downCount == 0) {-->
<!--            <div class="generic-card-dashboard">-->
<!--              <div class="flex items-center justify-between">-->
<!--                <div class="text-2xl font-medium ml-2"> Ongoing Incidences</div>-->
<!--                <div class="custom-style cursor-pointer" (click)="navigateToIncidents()">View all</div>-->
<!--              </div>-->

<!--              <div class="flex mt-3 items-center">-->
<!--                <div class="no-active-incident w-full flex flex-col items-center">-->
<!--                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <g clip-path="url(#clip0_835_464)">-->
<!--                      <mask id="mask0_835_464" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0"-->
<!--                            width="48"-->
<!--                            height="48">-->
<!--                        <path d="M48 0H0V48H48V0Z" fill="white"/>-->
<!--                      </mask>-->
<!--                      <g mask="url(#mask0_835_464)">-->
<!--                        <path-->
<!--                          d="M37.9998 40H11.9998C5.74858 40.0036 0.541618 35.2076 0.0325574 28.9772C-0.476502 22.7466 3.88288 17.1691 10.0518 16.158C12.8913 11.1238 18.2201 8.00701 23.9998 7.99987C27.6038 7.98625 31.1048 9.20259 33.9238 11.448C36.692 13.6437 38.66 16.6899 39.5238 20.116C44.6916 20.91 48.3754 25.551 47.9758 30.7642C47.5764 35.9774 43.2282 40.0028 37.9998 40ZM23.9998 12C19.6633 12.0051 15.6652 14.3442 13.5358 18.122L12.5998 19.8L10.7018 20.11C6.6024 20.7968 3.71184 24.5086 4.05026 28.6514C4.38866 32.7942 7.84328 35.9876 11.9998 36H37.9998C41.137 36.0032 43.747 33.5892 43.9882 30.4614C44.2294 27.3334 42.0204 24.5478 38.9198 24.07L36.2878 23.67L35.6438 21.086C34.3144 15.7396 29.509 11.9899 23.9998 12ZM21.0558 33.42L14.0558 26.42L16.8758 23.6L21.0558 27.78L30.2558 18.58L33.0758 21.4L21.0578 33.418L21.0558 33.42Z"-->
<!--                          fill="#34C759"/>-->
<!--                      </g>-->
<!--                    </g>-->
<!--                    <defs>-->
<!--                      <clipPath id="clip0_835_464">-->
<!--                        <rect width="48" height="48" fill="white"/>-->
<!--                      </clipPath>-->
<!--                    </defs>-->
<!--                  </svg>-->

<!--                  <div class="text-2xl my-2 text-center">No Active Incident</div>-->
<!--                  <div class="text-md my-2 text-center">Everything seems to be working fine</div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          } @else {-->
<!--            <div class="generic-card-dashboard">-->
<!--              <div class="flex items-center justify-between border-b pb-2 border-gray-200">-->
<!--                <div class="flex items-center gap-2">-->
<!--                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path-->
<!--                      d="M8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.4954 12.1402 12.1402 15.4954 8 15.5ZM7.25 10.25V11.75H8.75V10.25H7.25ZM7.25 4.25V8.75H8.75V4.25H7.25Z"-->
<!--                      fill="#EF4444"-->
<!--                    />-->
<!--                  </svg>-->
<!--                  <h3 class="text-lg font-semibold text-red-600"> Ongoing Incidences</h3>-->
<!--                </div>-->
<!--                <div class="custom-style cursor-pointer" (click)="navigateToIncidents()">View all</div>-->
<!--              </div>-->

<!--              <div class="grid-incident">-->
<!--                @for (incident of projectIncidents.slice(0, 4); let i = $index; track incident) {-->
<!--                  <div class="ongoing-card py-3">-->
<!--                    <div class="card-content flex items-start">-->
<!--                      <div class="incident-info flex items-center mr-2">-->
<!--                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                          <path-->
<!--                            d="M4.01019 7.42424L9.47035 13.7961C9.55836 13.8988 9.66753 13.9812 9.79038 14.0377C9.91323 14.0942 10.0468 14.1234 10.1821 14.1234C10.3173 14.1234 10.4509 14.0942 10.5737 14.0377C10.6966 13.9812 10.8058 13.8988 10.8938 13.7961L16.3539 7.42424C16.875 6.81604 16.443 5.87659 15.6422 5.87659H4.72035C3.91957 5.87659 3.48753 6.81604 4.01019 7.42424Z"-->
<!--                            fill="#DC2626"/>-->
<!--                        </svg>-->
<!--                        <span class="incident-count font-bold text-red-600">-->
<!--                          {{ incident.incidentCount }}-->
<!--                        </span>-->
<!--                      </div>-->

<!--                      <div>-->
<!--                        <h3 class="capitalize font-medium">{{ incident.project.name }}</h3>-->
<!--                        <div class="flex flex-col">-->
<!--                          @for (i of incident.incidents.slice(0, 2); track i) {-->
<!--                            <div class="mb-1">{{ i.monitor.name }}</div>-->
<!--                          }-->
<!--                        </div>-->

<!--                        @if (incident.incidents.length - 2 > 0) {-->
<!--                          <div class="more mt-3 h-8 flex items-center justify-center rounded-lg p-1">-->
<!--                            {{ incident.incidents.length - 2 }} more-->
<!--                          </div>-->
<!--                        }-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                }-->
<!--              </div>-->
<!--            </div>-->
<!--          }-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="flex gap-40 flex-wrap text-xs mb-4">-->
<!--        <div class="w-[19%] border-[2px]  px-2 rounded-xl border-gray-100 ml-14 py-3">-->
<!--          <div class="flex items-center gap-1 py-1">-->
<!--            <i class="pi pi-arrow-down text-gray-600 text-md"></i>-->
<!--            <span class="text-[16px] text-bold">Down</span>-->
<!--          </div>-->
<!--          <div class="ml-4 font-semibold text-[16px] text-gray-700">{{  downCount }}</div>-->
<!--        </div>-->

<!--        <div class="w-[19%] border-[2px] px-2 rounded-xl border-gray-100 py-3">-->
<!--          <div class="flex items-center gap-1 py-1">-->
<!--            <i class="pi pi-arrow-up text-gray-600 text-md"></i>-->
<!--            <span class="text-[16px] text-bold">Up</span>-->
<!--          </div>-->
<!--          <div class="ml-4 font-semibold text-[16px] text-gray-700">{{upCount}}</div>-->
<!--        </div>-->

<!--        <div class="w-[19%] border-[2px] px-2 rounded-xl border-gray-100 py-3">-->
<!--          <div class="flex items-center gap-1 py-1">-->
<!--            <i class="pi pi-pause text-gray-600 text-md"></i>-->
<!--            <span class="text-[16px] text-bold">Paused</span>-->
<!--          </div>-->
<!--          <div class="ml-4 font-semibold text-[16px] text-gray-700">{{ pausedCount }}</div>-->
<!--        </div>-->
<!--      </div>-->

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4 mb-5">
      <!-- Down Card -->
      <div class="bg-gradient-to-br from-primary-50 to-white border border-gray-100 rounded-xl p-5 shadow-sm">
        <div class="flex items-center gap-2 mb-2">
          <i class="pi pi-arrow-down text-red-400 text-lg"></i>
          <span class="text-base font-semibold text-gray-800">Down</span>
        </div>
        <div class="text-xl font-bold text-gray-700 ml-4">{{ downCount }}</div>
      </div>

      <!-- Up Card -->
      <div class="bg-gradient-to-br from-primary-50 to-white border border-gray-100 rounded-xl p-5 shadow-sm">
        <div class="flex items-center gap-2 mb-2">
          <i class="pi pi-arrow-up text-green-400 text-lg"></i>
          <span class="text-base font-semibold text-gray-800">Up</span>
        </div>
        <div class="text-xl font-bold text-gray-700 ml-4">{{ upCount }}</div>
      </div>

      <!-- Paused Card -->
      <div class="bg-gradient-to-br from-primary-50 to-white border border-gray-100 rounded-xl p-5 shadow-sm">
        <div class="flex items-center gap-2 mb-2">
          <i class="pi pi-pause text-yellow-400 text-lg"></i>
          <span class="text-base font-semibold text-gray-800">Paused</span>
        </div>
        <div class="text-xl font-bold text-gray-700 ml-4">{{ pausedCount }}</div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        @if (!projectId) {
          <div class="generic-card-dashboard-ongoing mt-1 w-full bg-[#f5f6fa] rounded-xl p-3">
            <h3 class="border-b pb-3 border-gray-200 text-lg font-semibold text-gray-700">Ongoing Incidents</h3>

            @if (loading) {
              <app-skeleton-table [loading]="loading" [headers]="incidentHeader"></app-skeleton-table>
            }

            @if (incidentsData.length > 0) {
              <p-table
                [value]="incidentsData"
                [expandedRowKeys]="expandedRows"
                [rowExpandMode]="'multiple'"
                dataKey="id"
                stripedRows
                [tableStyle]="{ 'min-width': '50rem' }"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 3rem;"></th>
                    <th>Project Name</th>

                    <th>Monitor Name</th>
                    <th>Started</th>
                    <th>Duration</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item  let-expanded="expanded">
                  <tr class="text-sm">
                    <td>
                      <a href="#" [pRowToggler]="item">
                        <i
                          class="pi"
                          [ngClass]="{
                        'pi-chevron-down': expanded,
                        'pi-chevron-right': !expanded
                      }"
                        ></i>
                      </a>
                    </td>
                    <td>
            <span
              (click)="navigateToProject(item.project.id)"
              class="cursor-pointer text-primary-500 hover:text-primary-600"
            >
              {{ item.project.name }}
            </span>
                    </td>
                    <td>
            <span
              (click)="navigateToMonitor(item.project.id,item.monitor.id)"
              class="cursor-pointer text-primary-400 hover:text-primary-500"
            >
              {{ item.monitor.name }}
            </span>
                    </td>

                    <!--                    <td>{{ item.monitor.name }}</td>-->
                    <td>{{ item.createdDate | date: 'dd-MM-yyyy HH:mm' }}</td>
                    <td>{{ item.incidentDuration | duration }}</td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="rowexpansion" let-item>
                  <tr>
                    <td colspan="5">
                      <div class="p-3 text-sm text-gray-700">
                        <strong>Root Cause:</strong>
                        <div class="mt-1 whitespace-pre-wrap">
                          <pre class="code-block">{{ item.rootCause | json }}</pre>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            } @else if (incidentsData.length == 0 && !loading) {
              <app-empty [emptyStateMessage]="'There is no incidents. Everything seems to be working fine'"></app-empty>
            }
          </div>
        }
      </div>
    </div>
  </div>
</app-content-wrapper>
